import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private formDataStore = new Map<string, any>();
  private formDataSubject = new BehaviorSubject<Map<string, any>>(this.formDataStore);

  saveFormData(formKey: string, data: any): void {
    this.formDataStore.set(formKey, data);
    this.formDataSubject.next(this.formDataStore);
  }

  getFormData(formKey: string): any {
    return this.formDataStore.get(formKey);
  }

  clearFormData(formKey: string): void {
    this.formDataStore.delete(formKey);
    this.formDataSubject.next(this.formDataStore);
  }

  getFormDataObservable() {
    return this.formDataSubject.asObservable();
  }
}
